export default __webpack_public_path__ + "static/media/rarity.e3a95daf.png";